/* Shopify glue for Tam's single-page design: Shopify URLs open the matching view, accounts are Shopify's,
   the contact form and the email popup post to Shopify. */
(() => {
  const BL = window.BL || {}, R = BL.routes || {};
  /* contact form -> Shopify contact (Tam's handler still shows the thank-you) */
  document.addEventListener("submit", (e) => {
    const f = e.target;
    if (f.matches(".ct-form") && !f.matches(".ac-form")) {
      const v = (n) => (f.elements[n] ? f.elements[n].value.trim() : "");
      if (!v("name") || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v("email")) || !v("message")) return;
      const fd = new FormData(); fd.append("form_type", "contact"); fd.append("utf8", "✓");
      fd.append("contact[name]", v("name")); fd.append("contact[email]", v("email"));
      fd.append("contact[body]", `Topic: ${v("topic")}\nOrder: ${v("order") || "-"}\n\n${v("message")}`);
      fetch(R.contact_url || "/contact", { method: "POST", body: fd }).catch(() => {});
    }
    if (f.matches(".pop-form")) {
      const input = f.querySelector("input[type=email], input");
      const em = input ? input.value.trim() : "";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) return;
      const fd = new FormData(); fd.append("form_type", "customer"); fd.append("utf8", "✓");
      fd.append("contact[email]", em); fd.append("contact[tags]", "newsletter,popup-welcome10");
      fetch(R.contact_url || "/contact", { method: "POST", body: fd }).catch(() => {});
    }
  }, true);
})();
